import { Link } from "react-router-dom";
import { thumb } from "../lib/img";
import { ShoppingBag } from "lucide-react";

const COLOR_MAP = { Bianca: "#FFFFFF", Rosa: "#F4A7BB", Viola: "#8B5CF6", Gialla: "#FACC15", Rossa: "#EF4444" };

export const CatalogProductCard = ({ product, className = "" }) => (
  <Link to={`/products/${product.id}`} className={`group block ${className}`} data-testid={`product-card-${product.id}`}>
    <div className="aspect-square overflow-hidden mb-4 bg-[#F5F0E8] rounded-lg">
      {product.images?.[0] ? (
        <img src={thumb(product.images[0], 480)} alt={product.name} loading="lazy" decoding="async" className="w-full h-full object-contain p-2 transition-transform duration-700 group-hover:scale-105" />
      ) : (
        <div className="w-full h-full flex items-center justify-center"><ShoppingBag className="h-10 w-10 text-[#7A8C69]/30" /></div>
      )}
    </div>
    <span className="text-xs uppercase tracking-wider text-brand-pink font-medium">{product.category}</span>
    <h3 className="font-serif text-forest mt-1 leading-snug group-hover:text-forest-light transition-colors line-clamp-2 sm:line-clamp-1">{product.name}</h3>
    <p className="text-sage font-semibold mt-1"><span className="text-xs font-normal">da </span>€{(product.display_price ?? product.price).toFixed(2)}</p>
    {product.available_colors?.length > 0 && (
      <div className="flex items-center gap-1.5 mt-2" data-testid="product-colors">
        {product.available_colors.map((color) => (
          <span key={color} title={color} className="w-4 h-4 rounded-full border border-gray-300" style={{ backgroundColor: COLOR_MAP[color] || "#ccc" }} />
        ))}
        <span className="text-xs text-sage ml-1">{product.available_colors.length} colori</span>
      </div>
    )}
  </Link>
);
